import { useUser } from '../../../entites/authorization/use-user.ts';
import { OrderCard, OrderCardProps } from '@ui/order/order-card';
import { useNavigate } from 'react-router-dom';
import { useOrderService } from '../../../entites/order/use-order.service.ts';
import { OrderUti } from '@shared/const/order.ts';

export const ActiveOrders = () => {
  const { isAuthenticated } = useUser();
  const navigate = useNavigate();

  const service = useOrderService({});

  const data: (OrderCardProps | undefined)[] =
    service.data?.data
      .filter(({ status }) => status < 5)
      .map((item) => {
        return {
          number: `# ${item.id}`,
          variant: 'secondary',
          status: OrderUti.status(item.status),
          total: `${item.total_price} ₸`,
          images: item.items.map((product) => product.product.main_photo),
          onPress: () => navigate(`/orders/${item.id}`),
        };
      }) || [];

  if (!isAuthenticated) return null;
  if (data && data.length === 0) return null;
  return (
    <>
      <p className="text-[#222223] pt-4 font-semibold text-base lg:hidden">
        Активные заказы: {data.length}
      </p>

      <div className="my-4 -mx-4 px-4 snap-x snap-mandatory flex flex-row gap-x-3 overflow-y-scroll no-scroll-bar lg:hidden">
        {data.map((card, index) => (
          <OrderCard key={index} {...card} />
        ))}
      </div>

      <div className="bg-[#F8F9FA] h-2 -mx-4 lg:hidden" />
    </>
  );
};
